import { GET_ONE } from 'react-admin';

const getRefundNoteUrl = (useBusinessClient, fleetID, id, paymentRefundPspReference) => {
  const baseUrl = useBusinessClient
    ? `/business/fleets/${fleetID}/instant-invoices/${id}`
    : `/user/billing/fleets/${fleetID}/invoices/${id}`;
  return `${baseUrl}/refundNote${
    paymentRefundPspReference ? `?paymentRefundPspReference=${paymentRefundPspReference}` : ''
  }`;
};

const dataBusinessUnitInvoicesRefundableAmount = (
  instance,
  type,
  { field, id, actionType, paymentRefundPspReference, useBusinessClient }
) => {
  const opt = {};
  switch (type) {
    case GET_ONE: {
      switch (field) {
        case 'refundableAmount':
          opt.url = `/user/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/refundableAmount`;
          opt.method = 'GET';
          break;

        case 'refundNote':
          opt.url = getRefundNoteUrl(useBusinessClient, localStorage.getItem('fleetID'), id, paymentRefundPspReference);
          opt.method = 'GET';
          opt.responseType = 'blob';
          opt.headers = {
            Accept: 'application/pdf',
          };
          break;

        case 'invoicePdf':
          opt.url = useBusinessClient
            ? `/business/fleets/${localStorage.getItem('fleetID')}/instant-invoices/${id}/pdf`
            : `/user/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/pdf`;
          opt.method = 'GET';
          opt.responseType = 'blob';
          opt.headers = {
            Accept: 'application/pdf',
          };
          break;

        default:
          break;
      }
      break;
    }
    default:
      throw new Error(`Unsupported action type ${actionType}`);
  }

  return instance(opt);
};

export default dataBusinessUnitInvoicesRefundableAmount;
